class BankApi {
    // Bank Statement Document Management
    removeBankStatementDocuments(bankStatementId, documentId) {
        var url = apiUrl + 'banks/removeDocument/' + bankStatementId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    updateStatement(id, data) {
        console.log('Updating statement with ID:', id, 'and data:', data);
        var url = apiUrl + 'banks/updateDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    addStatement(id, data) {
        var url = apiUrl + 'banks/addDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    // Enhanced Bank List Methods with Pagination and Filtering
    getListByCurrentBusiness(params = {}) {
        var url = apiUrl + 'banks/currentBusiness/';
        
        // Build query parameters
        const queryParams = new URLSearchParams();
        
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);
        if (params.bankName) queryParams.append('bankName', params.bankName);
        if (params.accountNumber) queryParams.append('accountNumber', params.accountNumber);
        if (params.accountType) queryParams.append('accountType', params.accountType);
        if (params.status) queryParams.append('status', params.status);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getListByCurrentTenant(params = {}) {
        var url = apiUrl + 'banks/currentUser/';
        
        // Build query parameters
        const queryParams = new URLSearchParams();
        
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Basic CRUD Operations
    getList(params = {}) {
        var url = apiUrl + 'banks';
        
        // Add query parameters if provided
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    get(id) {
        var url = apiUrl + 'banks/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    create(data) {
        // Ensure required fields are present
        const bankData = {
            name: data.name,
            accountName: data.accountName,
            accountNo: data.accountNo,
            accountType: data.accountType || 'Business Account',
            balance: parseFloat(data.balance) || 0,
            currency: data.currency || 'MYR',
            status: data.status || 'Active',
            minBalance: parseFloat(data.minBalance) || 0,
            notes: data.notes || ''
        };

        var url = apiUrl + 'banks';
        return api.call('post', url, bankData)
            .then(({ data }) => {
                return data
            });
    }

    update(data) {
        // Ensure required fields are present and properly typed
        const bankData = {
            id: data.id,
            businessId: data.businessId,  // CRITICAL: Preserve BusinessId to avoid FK constraint violation
            name: data.name,
            accountName: data.accountName,
            accountNo: data.accountNo,
            accountType: data.accountType || 'Business Account',
            balance: parseFloat(data.balance) || 0,
            currency: data.currency || 'MYR',
            status: data.status || 'Active',
            minBalance: parseFloat(data.minBalance) || 0,
            notes: data.notes || ''
        };

        var url = apiUrl + 'banks/';
        return api.call('put', url + data.id, bankData)
            .then(({ data }) => {
                return data
            });
    }

    delete(id) {
        var url = apiUrl + 'banks/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

    // Bank Summary and Analytics
    getSummary() {
        var url = apiUrl + 'banks/summary/currentBusiness';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Bank Account Status Management
    updateStatus(id, status) {
        var url = apiUrl + 'banks/' + id + '/status';
        return api.call('put', url, { status: status })
            .then(({ data }) => {
                return data
            });
    }

    activate(id) {
        return this.updateStatus(id, 'Active');
    }

    deactivate(id) {
        return this.updateStatus(id, 'Inactive');
    }

    close(id) {
        return this.updateStatus(id, 'Closed');
    }

    // Balance Management
    updateBalance(id, balance) {
        var url = apiUrl + 'banks/' + id + '/balance';
        return api.call('put', url, { balance: parseFloat(balance) })
            .then(({ data }) => {
                return data
            });
    }

    // Bank Statement Bulk Operations
    bulkUploadStatements(bankId, statements) {
        var url = apiUrl + 'banks/' + bankId + '/statements/bulk';
        return api.call('post', url, statements)
            .then(({ data }) => {
                return data
            });
    }

    // Reconciliation
    reconcileAccount(id, reconciliationData) {
        var url = apiUrl + 'banks/' + id + '/reconcile';
        return api.call('post', url, reconciliationData)
            .then(({ data }) => {
                return data
            });
    }

    getReconciliationHistory(id, params = {}) {
        var url = apiUrl + 'banks/' + id + '/reconciliation-history';
        
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
        if (params.dateTo) queryParams.append('dateTo', params.dateTo);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Export Functionality
    exportAccount(id, format = 'csv') {
        var url = apiUrl + 'banks/' + id + '/export?format=' + format;
        return api.call('get', url, null, { responseType: 'blob' })
            .then(({ data }) => {
                return data
            });
    }

    exportAllAccounts(format = 'csv') {
        var url = apiUrl + 'banks/export/currentBusiness?format=' + format;
        return api.call('get', url, null, { responseType: 'blob' })
            .then(({ data }) => {
                return data
            });
    }

    // Transaction Management (if transactions are separate from statements)
    getTransactions(bankId, params = {}) {
        var url = apiUrl + 'banks/' + bankId + '/transactions';
        
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
        if (params.dateTo) queryParams.append('dateTo', params.dateTo);
        if (params.type) queryParams.append('type', params.type);
        if (params.minAmount) queryParams.append('minAmount', params.minAmount);
        if (params.maxAmount) queryParams.append('maxAmount', params.maxAmount);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    addTransaction(bankId, transaction) {
        var url = apiUrl + 'banks/' + bankId + '/transactions';
        return api.call('post', url, transaction)
            .then(({ data }) => {
                return data
            });
    }

    updateTransaction(bankId, transactionId, transaction) {
        var url = apiUrl + 'banks/' + bankId + '/transactions/' + transactionId;
        return api.call('put', url, transaction)
            .then(({ data }) => {
                return data
            });
    }

    deleteTransaction(bankId, transactionId) {
        var url = apiUrl + 'banks/' + bankId + '/transactions/' + transactionId;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }

    // Bank Account Validation
    validateAccountNumber(bankName, accountNumber) {
        var url = apiUrl + 'banks/validate-account';
        return api.call('post', url, { 
            bankName: bankName, 
            accountNumber: accountNumber 
        })
        .then(({ data }) => {
            return data
        });
    }

    // Bank Statement Processing and Analysis
    processStatement(bankId, statementId) {
        var url = apiUrl + 'banks/' + bankId + '/statements/' + statementId + '/process';
        return api.call('post', url)
            .then(({ data }) => {
                return data
            });
    }

    getStatementAnalysis(bankId, statementId) {
        var url = apiUrl + 'banks/' + bankId + '/statements/' + statementId + '/analysis';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Bank Account Health Check
    getAccountHealth(id) {
        var url = apiUrl + 'banks/' + id + '/health';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getAllAccountsHealth() {
        var url = apiUrl + 'banks/health/currentBusiness';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Dashboard and Analytics
    getDashboardData() {
        var url = apiUrl + 'banks/dashboard/currentBusiness';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getCashFlowAnalysis(params = {}) {
        var url = apiUrl + 'banks/cash-flow/currentBusiness';
        
        const queryParams = new URLSearchParams();
        if (params.period) queryParams.append('period', params.period); // 'monthly', 'quarterly', 'yearly'
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
        if (params.dateTo) queryParams.append('dateTo', params.dateTo);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getBalanceTrends(bankId, params = {}) {
        var url = apiUrl + 'banks/' + bankId + '/balance-trends';
        
        const queryParams = new URLSearchParams();
        if (params.period) queryParams.append('period', params.period);
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
        if (params.dateTo) queryParams.append('dateTo', params.dateTo);
        
        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Notification and Alert Management
    getAlerts(bankId) {
        var url = apiUrl + 'banks/' + bankId + '/alerts';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    updateAlertSettings(bankId, alertSettings) {
        var url = apiUrl + 'banks/' + bankId + '/alert-settings';
        return api.call('put', url, alertSettings)
            .then(({ data }) => {
                return data
            });
    }

    // Bank Account Backup and Restore
    backupAccount(id) {
        var url = apiUrl + 'banks/' + id + '/backup';
        return api.call('post', url, null, { responseType: 'blob' })
            .then(({ data }) => {
                return data
            });
    }

    restoreAccount(backupFile) {
        var url = apiUrl + 'banks/restore';
        const formData = new FormData();
        formData.append('backup', backupFile);
        
        return api.call('post', url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(({ data }) => {
            return data
        });
    }

    // Error handling helper
    handleApiError(error) {
        if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.message) {
                throw new Error(errorData.message);
            } else if (errorData.errors && Array.isArray(errorData.errors)) {
                throw new Error(errorData.errors.join(', '));
            }
        }
        throw error;
    }
}

export default BankApi;